import * as Handlebars from 'handlebars/runtime';

window.Handlebars = Handlebars;
